// extracted by mini-css-extract-plugin
module.exports = {"line1":"styles_line1__Tw1oR","title":"styles_title__3xF23"};